<template>
  <div class="custom-order">
    <Breadcrumb></Breadcrumb>

    <!-- 过滤条件 -->
    <div class="form-body">
      <el-form :model="form" ref="form" label-width="80px">
        <el-row :gutter="20">
          <el-col :span="24">
            <div class="grid-content bg-purple">
              <el-form-item label="店铺名称：" class="item">
                <div
                  style="
                    max-height: 200px;
                    overflow-y: auto;
                    float: left;
                    width: calc(100% - 59px);
                  "
                >
                  <el-input
                    v-if="isExpand"
                    style="width: 139px; margin: 0 29px 0 0"
                    v-model="shopName"
                    size="small"
                    placeholder="店铺名称"
                  ></el-input>
                  <el-checkbox @change="handleChangeShop" v-model="isCheckShop"
                    >全选</el-checkbox
                  >
                  <el-checkbox-group
                    filterable
                    v-model="form.shopId"
                    placeholder="请选择店铺名称"
                    class="input"
                    size="small"
                    clearable
                    style="display: inline; margin: 0 0 0 27px"
                  >
                    <el-checkbox
                      v-for="(item, index) in shopList"
                      :key="index"
                      :label="item.shopId"
                      v-show="
                        (isExpand || index < 10) &&
                          item.shopName.indexOf(shopName) > -1
                      "
                    >
                      {{ item.shopName
                      }}<span v-if="item.amazonSite"
                        >({{ dictMap["amazon_site"][item.amazonSite] }})</span
                      >
                    </el-checkbox>
                  </el-checkbox-group>
                </div>
                <div
                  v-if="shopList.length > 10"
                  @click="isExpand = !isExpand"
                  style="
                    margin: 0 0 0 16px;
                    cursor: pointer;
                    color: #409eff;
                    float: left;
                  "
                >
                  {{ isExpand ? "－收起" : "＋展开" }}
                </div>
              </el-form-item>
            </div>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="8">
            <div class="grid-content bg-purple">
              <el-form-item label="导入时间：" class="item">
                <el-date-picker
                  type="daterange"
                  placeholder="选择日期"
                  v-model="form.importTime"
                  class="input"
                  size="small"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  clearable
                ></el-date-picker>
              </el-form-item>
            </div>
          </el-col>
          <el-col style="text-align: right" :span="16">
            <el-button type="primary" size="small" @click="getData(1)">
              搜索
            </el-button>
            <el-button type="default" size="small" @click="reset">
              重置
            </el-button>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-dropdown @command="handleCommand">
              <el-button type="success" size="small">
                导入订单<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="amazon"
                  >导入亚马逊订单</el-dropdown-item
                >
                <el-dropdown-item command="lazada"
                  >导入lazada订单</el-dropdown-item
                >
                <el-dropdown-item command="shopee"
                  >导入shopee订单</el-dropdown-item
                >
                <el-dropdown-item command="universal"
                  >导入通用订单</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </el-col>
          <el-col :span="16"></el-col>
        </el-row>
      </el-form>
    </div>

    <!-- 表格 -->
    <div class="table-body">
      <div class="top">
        <div class="left"></div>
        <div class="right">
          <pagination
            :total="total"
            :page.sync="form.pageNum"
            :limit.sync="form.pageSize"
            @pagination="getData"
          />
        </div>
      </div>
      <el-table :data="tableData">
        <el-table-column
          label="导入编号"
          align="center"
          prop="importId"
        ></el-table-column>
        <el-table-column
          label="导入时间"
          align="center"
          prop="importTime"
        ></el-table-column>
        <el-table-column label="导入店铺" align="center" prop="shopName">
          <template slot-scope="scope">
            {{ shopMap[scope.row.shopId] }}
          </template>
        </el-table-column>
        <el-table-column
          label="导入订单数"
          align="center"
          prop="importNum"
          width="125"
        ></el-table-column>
        <el-table-column
          label="导入状态"
          align="center"
          prop="importStatus"
          width="125"
        >
          <template slot-scope="scope">
            {{ dictMap["import_status"][scope.row.importStatus] }}
          </template>
        </el-table-column>
        <el-table-column  align="center" width="125" label="平台渠道" prop="shopName">
          <template slot-scope="scope">
            <span> {{ dictMap["plat_no"][scope.row.platNo] }} </span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作人"
          align="center"
          prop="nickName"
          width="125"
        >
          <template slot-scope="scope">
            {{ scope.row.nickName ? scope.row.nickName : scope.row.operNo }}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="120">
          <template slot-scope="scope">
            <div class="operate">
              <span class="link" @click="view(scope.row)"> 查看 </span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <br />
      <pagination
        :total="total"
        :page.sync="form.pageNum"
        :limit.sync="form.pageSize"
        @pagination="getData"
      />
    </div>

    <!-- 查看订单弹窗 -->
    <ViewImportOrder
      :visible="showTable"
      @onClose="hideTable"
      :orderData="currentOrder"
    />

    <el-dialog
      :close-on-click-modal="false"
      :title="
        `导入${
          importType == 'amazon'
            ? '亚马逊'
            : importType == 'lazada'
            ? 'lazada'
            : importType == 'shopee'
            ? 'shopee'
            : importType == '通用'
        }订单`
      "
      :visible.sync="showModal"
      width="540px"
      class="remarkDialog"
      :before-close="handleClose"
    >
      <el-form
        :rules="rules"
        :model="importForm"
        ref="importForm"
        label-width="120px"
      >
        <el-form-item prop="shopId" label="选择店铺：">
          <el-cascader
            v-model="importForm.shopId"
            :options="options"
            @change="handleChangeSelect"
            size="small"
          ></el-cascader>
        </el-form-item>
        <el-form-item prop="file" label="选择文件：">
          <input
            type="file"
            name="file"
            class="webuploader"
            accept=""
            @change="uploadFn"
            ref="inputer"
          />
        </el-form-item>
        <el-form-item v-if="importType == 'universal'" label="模板样例：">
          <a
            target="_blank"
            href="https://files.onecust.com/downloads/template/1%E5%8F%B7%E5%AE%9A%E5%88%B6%E9%80%9A%E7%94%A8%E6%A8%A1%E6%9D%BF%E5%AF%BC%E5%85%A5.xlsx"
            >点此下载</a
          >
        </el-form-item>
        <el-form-item v-if="importType == 'lazada'" label="模板样例：">
          <a
            target="_blank"
            href="https://files.onecust.com/downloads/template/Lazada_Order.xlsx"
            >点此下载</a
          >
        </el-form-item>
        <el-form-item v-if="importType == 'shopee'" label="模板样例：">
          <a
            target="_blank"
            href="https://ec-shopmall.oss-cn-hangzhou.aliyuncs.com/downloads/template/Shopee_Order.xlsx"
            >点此下载</a
          >
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">返回</el-button>
        <el-button type="primary" @click="sure" size="small"> 保存 </el-button>
      </span>
    </el-dialog>

    <!-- 查看订单弹窗 -->
    <PreviewOrder
      :visible="showPreview"
      @onClose="showPreview = false"
      :orderData="successOrder"
    />
  </div>
</template>

<script>
import Breadcrumb from "@/components/common/Breadcrumb"
import ViewImportOrder from "./components/ViewImportOrder"
import PreviewOrder from "./components/PreviewOrder"
import { mapGetters } from "vuex"
import { getShopList } from "@/api/system/shopManage"
import {
  listImport,
  uploadOrder,
  getImportInfo,
  uploadUniversalOrder,
  uploadLazada,
  uploadShopee,
} from "@/api/order/all"
import dayjs from "dayjs"

export default {
  name: "order",
  components: {
    Breadcrumb,
    ViewImportOrder,
    PreviewOrder,
  },
  data() {
    return {
      total: 0,
      shopList: [],
      form: {
        // channel: "", // 平台渠道
        importTime: [], // 创建时间
        shopId: [], // 店铺名称
        pageNum: 1,
        pageSize: 10,
      },
      importForm: {
        shopId: "",
        file: null,
      },
      rules: {
        shopId: [{ required: true, message: "请选择店铺", trigger: "change" }],
        file: [{ required: true, message: "请选择文件", trigger: "change" }],
      },
      tableData: [], // 表格数据
      showTable: false,
      currentOrder: [],
      showModal: false,
      showPreview: false,
      successOrder: [],
      isCheckShop: true,
      isCheckStatus: true,
      isExpand: false,
      shopName: "",
      importType: "amazon",
      options: [],
    }
  },
  computed: {
    ...mapGetters(["dictData", "dictMap"]),
    shopMap() {
      let shopMap = {}
      this.shopList.map((el) => {
        shopMap[el.shopId] = el.shopName
      })
      return shopMap
    },
  },
  mounted() {
    this.getData()
    this.getShopList()
  },
  methods: {
    // 搜索
    getShopList() {
      getShopList().then((res) => {
        this.shopList = res.rows
        let options = [
          {
            value: "amazon",
            label: "亚马逊店铺",
            children: [],
          },
          {
            value: "lazada",
            label: "lazada店铺",
            children: [],
          },
          {
            value: "shopee",
            label: "shopee店铺",
            children: [],
          },
          {
            value: "shopline",
            label: "shopee店铺",
            children: [],
          },
          {
            value: "shopify",
            label: "shopify店铺",
            children: [],
          },
          {
            value: "店匠",
            label: "店匠店铺",
            children: [],
          },
          {
            value: "other",
            label: "其他店铺",
            children: [],
          },
        ]
        res.rows.map((record) => {
          if (record.platNo == "04") {
            options[0].children.push({
              value: record.shopId,
              label: record.shopName,
            })
          } else if (record.platNo == "03") {
            options[1].children.push({
              value: record.shopId,
              label: record.shopName,
            })
          } else if (record.platNo == "05") {
            options[2].children.push({
              value: record.shopId,
              label: record.shopName,
            })
          } else if (record.platNo == "07") {
            options[3].children.push({
              value: record.shopId,
              label: record.shopName,
            })
          } else if (record.platNo == "06") {
            options[4].children.push({
              value: record.shopId,
              label: record.shopName,
            })
          } else if (record.platNo == "08") {
            options[5].children.push({
              value: record.shopId,
              label: record.shopName,
            })
          } else {
            options[6].children.push({
              value: record.shopId,
              label: record.shopName,
            })
          }
        })

        if (this.importType == "amazon") {
          options.splice(1, 1)
          options.splice(1, 1)
          options.splice(1, 1)
          options.splice(1, 1)
          options.splice(1, 1)
        } else if (this.importType == "lazada") {
          options.splice(0, 1)
          options.splice(1, 1)
          options.splice(1, 1)
          options.splice(1, 1)
          options.splice(1, 1)
        } else if (this.importType == "shopee") {
          options.splice(0, 1)
          options.splice(0, 1)
          options.splice(1, 1)
          options.splice(1, 1)
          options.splice(1, 1)
        }
        this.options = options

        // this.handleChangeShop()
      })
    },
    getData() {
      this.startLoading()

      let params = Object.assign({}, this.form)
      params.shopId = params.shopId.join(",")
      if (params.shopId == "" && this.isCheckShop) {
        let shopId = []
        for (let record of this.shopList) {
          shopId.push(record.shopId)
        }
        params.shopId = shopId.join(",")
      }

      if (this.form.importTime && this.form.importTime.length > 0) {
        params["beginTime"] = dayjs(this.form.importTime[0]).format(
          "YYYY-MM-DD"
        )
        params["endTime"] = dayjs(this.form.importTime[1]).format("YYYY-MM-DD")
      }

      delete params["importTime"]

      listImport(params)
        .then((res) => {
          this.tableData = res.rows
          this.total = res.total
          this.endLoading()
        })
        .catch(() => {
          this.endLoading()
        })
    },
    handleChangeShop() {
      this.form.shopId = []
      if (this.isCheckShop) {
        this.shopList.map((record) => {
          this.form.shopId.push(record.shopId)
        })
      }
    },
    // 重置
    reset() {
      this.form = {
        importTime: [], // 创建时间
        shopId: [], // 店铺名称
        pageNum: 1,
        pageSize: 10,
      }
    },
    importOrders() {
      this.importForm = {
        shopId: "",
        file: [],
      }
      this.$refs.inputer ? (this.$refs.inputer.value = "") : ""
      this.getShopList()
      this.showModal = true
      this.$nextTick(() => {
        this.$refs["importForm"].clearValidate()
      })
    },
    handleClose() {
      this.importForm = {
        shopId: "",
        file: [],
      }
      this.$refs.inputer ? (this.$refs.inputer.value = "") : ""
      this.showModal = false
    },
    uploadFn() {
      let inputDOM = this.$refs.inputer
      let file = inputDOM.files

      this.importForm.file = file
    },
    sure() {
      this.$refs["importForm"].validate((valid) => {
        if (valid) {
          let formData = new FormData()

          formData.append("file", this.importForm.file[0])
          formData.append("shopId", this.importForm.shopId[1])

          let uploadMethod = uploadOrder

          if (this.importType == "amazon") {
            uploadMethod = uploadOrder
          } else if (this.importType == "universal") {
            uploadMethod = uploadUniversalOrder
          } else if (this.importType == "lazada") {
            uploadMethod = uploadLazada
          } else if (this.importType == "shopee") {
            uploadMethod = uploadShopee
          }

          uploadMethod(formData).then((res) => {
            if (res.code !== 200) {
              this.$message.error("上传失败")
            } else {
              this.$message.success("上传成功")
              this.showModal = false
              // this.successOrder = res.rows
              // this.showPreview = true
              this.getData()
            }
          })
        }
      })
    },
    // 查看
    view(data) {
      getImportInfo(data.importId).then((res) => {
        let originId = ""
        if (res.data.amazonOrderList.length > 0) {
          originId = res.data.amazonOrderList[0].orderId
        }
        let index = 1
        for (let record of res.data.amazonOrderList) {
          let count = 0
          let orderId = record.orderId
          for (let i = 0; i < res.data.amazonOrderList.length; i++) {
            if (res.data.amazonOrderList[i].orderId == orderId) {
              count++
            }
          }

          if (originId != orderId) {
            originId = orderId
            index++
          }
          record.index = index
          record.count = count
        }
        for (let i = 1; i < res.data.amazonOrderList.length; i++) {
          if (
            res.data.amazonOrderList[i].orderId ==
            res.data.amazonOrderList[i - 1].orderId
          ) {
            res.data.amazonOrderList[i].count = 0
          }
        }
        this.currentOrder = res.data.amazonOrderList || []

        this.showTable = true
      })
    },
    hideTable() {
      this.showTable = false
    },
    handleCommand(command) {
      this.importType = command
      this.importOrders()
    },
    handleChangeSelect() {},
  },
}
</script>

<style scoped>
.form-body {
  padding: 10px 20px;
}

.form-body .item.right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.table-body {
  margin-top: 10px;
  border: 1px solid #ebeef5;
  background: #fff;
  font-size: 12px;
}

.table-body /deep/.el-table .cell {
  padding: 0;
}

.table-body .top {
  padding: 0 0 8px 0;
  background: #fff;
  display: flex;
  justify-content: space-between;
  padding-right: 0;
}

.table-body .table {
  margin-bottom: 10px;
}

.table-info-wrap {
  margin-bottom: -10px;
}

.table-info {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #ebeef5;
  margin-bottom: 10px;
  padding: 0 10px;
}

.table-info:last-child {
  margin-bottom: 0;
  border-bottom: 0;
}

.table-info .left {
  margin-right: 20px;
  width: 100px;
  background-color: #fff;
  border: 1px solid #ebeef5;
  min-height: 100px;
  margin-bottom: 10px;
}

.table-info .left .mini-img {
  width: 95px;
  height: 95px;
}

.table-info .right {
  font-size: 12px;
}

.loan-wrap {
  display: flex;
  flex-direction: column;
  display: flex;
  flex-direction: column;
  padding: 0 10px;
  font-size: 12px;
  text-align: left;
}

.loan-wrap .title.lw40 {
  width: 24px;
}

.loan-wrap .title {
  width: 48px;
  display: inline-block;
  text-align: justify;
  text-align-last: justify;
}

.operate {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.operate .link {
  font-size: 12px;
  color: #1e7ec8;
  cursor: pointer;
}

.table /deep/.el-table_1_column_1 {
  width: 0px !important;
  height: 0px !important;
}

.table /deep/.el-table_1_column_1 .cell {
  visibility: hidden !important;
  cursor: not-allowed !important;
}

.table /deep/.el-table__expanded-cell[class*="cell"] {
  padding: 8px 16px;
}
</style>
